// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"659ef2e9","455":"dab9631f","939":"28739c93","977":"1cfc9d16"}[chunkId] + ".chunk.js";
};